const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getCurrentUser() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users/me`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
  } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

// Función para generar y guardar el hash de Chatbase
export async function generateChatbaseHash(userId, chatbaseUserId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/chatbasehash/`, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
      body: JSON.stringify({
        user_id: userId,
        chatbase_user_id: chatbaseUserId
      })
    });
    return await response.json();
  } catch (error) {
    console.error(error);
  }
}